import { useMemo } from 'react';
import { useTranslation } from '@weareconceptstudio/core';

//* Styles
import ButtonStyle from './style';

import CustomLink from '../CustomLink';

const Button = ({ btnType, text, className, onClick, url, type = 'button', disabled = false, children, external = false, ariaLabel = url }) => {
	const { translate } = useTranslation();

	//! Checks
	const Component = useMemo(() => (url ? CustomLink : 'button'), [url]);
	const customProps = useMemo(() => (url ? { url, ariaLabel, external } : { type, disabled }), [url, external, type, disabled, ariaLabel]);

	let btn;

	switch (btnType) {
		default:
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${btnType || ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
				>
					<Component {...customProps}>{children || translate(text)}</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default Button;
